import React from "react";
import PageBanner from "../../components/TermsPageComponents/PageBanner";
import { pgImg14, pgImg15 } from "../../components";

function WebsiteSecurityManagement() {
  return (
    <>
      <section id="securityServicesPage" className="securityServicesPage">
        <div className="pagesBanner">
          <PageBanner PageTitle="Website Security Management" />

          <div className="shapeSvg">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15002 2408">
              <g id="Layer_x0020_1">
                <metadata id="CorelCorpID_0Corel-Layer" />
                <path
                  className="fil0"
                  d="M14999.66 160.41l0 2250.5 -15002 0 0 -2408.48c4.48,15.46 34.05,38.31 47.09,51.36 18.3,18.3 33.31,33.31 51.61,51.61l377.15 322.94c339.34,254.69 723.38,451.6 1129.12,576.25 740.24,227.38 1518.28,209.44 2250.74,-34.78 297.55,-99.2 684.02,-289.57 933.07,-476.11 87.62,-65.63 227.27,-165.69 307.34,-240.17 31.42,-29.23 114.35,-99.39 131.22,-124.58 20,4.66 99.59,47.55 124.17,59.83 42.41,21.2 81.55,40.72 122.67,61.33l125.61 58.39c133.82,59.52 249.76,112.63 391.76,169.22 238.34,95 587.91,216.82 832.54,284.94 200.63,55.86 382.28,106.97 590.69,154.3 1557.59,353.7 3775.68,425.94 5382.01,17.95 25.54,-6.48 49.29,-10.39 73.59,-16.17l373.43 -93.31c198.88,-54.19 343.18,-97.87 536.61,-159.02l312.66 -109.2c47.88,-17.88 90.5,-33.57 136.53,-51.96 82.88,-33.12 316.41,-125.5 392.57,-163.92l128.78 -59.7c23.6,-10.77 225.99,-115.13 251.04,-121.22z"
                />
              </g>
            </svg>
          </div>
        </div>
      </section>
      <section
        id="securityServicesContentWrap"
        className="securityServicesContentWrap"
      >
        <div className="container">
          <div className="col-md-12 col-12">
            <div className="contentWrap">
              <div className="row">
                <div className="col-md-7">
                  <p>
                    In the rapidly evolving landscape of technology, businesses
                    often find themselves continuously engaged without taking
                    the necessary pause to prioritize their company's security.
                    This oversight represents one of the most significant errors
                    they can make, potentially leading to wide-ranging data
                    breaches or other security complications. It's not widely
                    known that companies have the option to entrust the entirety
                    of their security needs to a specialized firm with a team of
                    dedicated professionals who vigilantly oversee their
                    security posture. This comprehensive solution is commonly
                    referred to as the Annual Website Security Management
                    service. If you're seeking a reputable and well-established
                    security partner to manage these critical aspects for your
                    business, Version Next Technologies presents itself as a
                    highly favorable choice.
                  </p>
                  <div className="sedtionTitle">
                    <h4>
                      What Makes Version Next Technologies the Optimal Selection
                      for this Service?
                    </h4>
                  </div>
                  <p>
                    We provide an extensive range of security services in
                    Mumbai, and regardless of your company's location, our team
                    is equipped to serve businesses of all sizes. Without
                    regular security audits, it's challenging to guarantee
                    complete safety for your organization. That's why we offer
                    meticulously planned security audit reports at regular
                    intervals, allowing you to focus solely on your work without
                    the added worry. Should a threat arise, our team promptly
                    takes action to address it, ensuring no data or files are
                    compromised.
                  </p>
                </div>
                <div className="col-md-5">
                  <div className="pageImgWrap">
                    <img src={pgImg14} alt="Website Security Management" />
                  </div>
                </div>
              </div>
            </div>
            <div className="contentWrap"></div>
            <div className="contentWrap">
              <div className="row">
                <div className="col-md-5">
                  <div className="pageImgWrap">
                    <img src={pgImg15} alt="Website Security Management" />
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="sedtionTitle">
                    <h4>
                      Which services are encompassed within the Annual Website
                      Security Management package?
                    </h4>
                  </div>
                  <p>
                    Under our Annual Website Security Management service, you
                    gain access to a wide array of services. Our expert security
                    team is dedicated to continually reviewing and enhancing
                    your business's information technology security. Here's an
                    overview of the comprehensive offerings included with this
                    service:
                  </p>
                  <ul>
                    <li>
                      <b>Employee Training:</b> We provide training to empower
                      your employees with the knowledge and skills to enhance
                      their security practices in their daily tasks.
                    </li>
                    <li>
                      <b>Malware Monitoring:</b> We continuously monitor all
                      your servers and IPs to detect and mitigate potential
                      malware threats that could jeopardize your network
                      security.
                    </li>
                    <li>
                      <b>Application Security Review:</b> We conduct thorough
                      reviews of your web and mobile applications to identify
                      and address any existing vulnerabilities that may pose
                      risks.
                    </li>
                    <li>
                      <b>Annual Server and Application Checks:</b> On an annual
                      basis, we perform extensive assessments of your servers
                      and web-based applications to ensure they meet security
                      standards and make any necessary recommendations or
                      adjustments.
                    </li>
                    <li>
                      <b>Vulnerability Assessment and Penetration Testing:</b>{" "}
                      As one of the premier Vulnerability Assessment and
                      Penetration Testing services in Mumbai, we provide both of
                      these critical security assessments as part of our Annual
                      Website Security Management service.
                    </li>
                  </ul>
                  <p>
                    This revised version provides a clear and concise
                    description of the services included in the package.
                  </p>
                </div>
              </div>

              <p>
                Our generated reports are tailor-made specifically for your
                business, offering a comprehensive overview of your firm's
                security status at a glance. These reports are designed with
                readability in mind, providing in-depth coverage of all
                essential aspects necessary for a fully secure environment.
                Additionally, we offer multiple revisions and solutions for the
                same issue, allowing you to select the one that aligns best with
                your preferences. These services, along with many others, are
                encompassed within our offering. For further information, please
                don't hesitate to reach out to us at +91 7039 003 001 or send an
                email to sales@version-next.com .
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default WebsiteSecurityManagement;
